import React, { useEffect, useState } from "react";
import styles from "./ContextList.module.css";
import ContextCard from "./ContextCard";
import { EditablePair } from "../../../../../api/responsePayload/KnowledgeResponse";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/common/hooks";
import {
  addEditablePair,
  deleteEditablePair,
  setContextSelected,
} from "../../../../../store/context.slice";

interface ContextListProps {}

const ContextList: React.FC<ContextListProps> = ({}) => {
  const [selectedCardId, setSelectedCardId] = useState<number | null>(null);
  const dispatch = useAppDispatch();
  const context = useAppSelector((s) => s.context.items);

  const handleCardSelected = (
    checked: boolean,
    contextId: number,
    pairs: EditablePair[]
  ) => {
    if (checked) {
      dispatch(addEditablePair({ contextId, pairs }));
    } else {
      dispatch(deleteEditablePair({ contextId }));
    }
  };

  useEffect(() => {
    dispatch(setContextSelected({ isSelected: selectedCardId !== null }));
  }, [selectedCardId, dispatch]);

  return (
    <div className={styles["question-group-scroll-container"]}>
      {context.map((context) => (
        <ContextCard
          key={context.id}
          context={context}
          onChecked={handleCardSelected}
          checked={selectedCardId === context.id}
          setChecked={() => {
            setSelectedCardId((prevId) =>
              prevId === context.id ? null : context.id
            );
          }}
        />
      ))}
    </div>
  );
};

export default ContextList;
